import React, { FunctionComponent, useState, useRef } from "react";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import { themeColors } from "../../Components/theme";
import "../../theme-vars.css";


type props = { history: any; user: any, theme: any };
const PolicyPrivacy: FunctionComponent<props> = ({ history, user, theme }) => {
    const containerStyles = { 
        backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, 
        color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
    }
    const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
    return (
        <div
            className="container-fluid p-4 d-flex flex-column gap-4"
            style={{ minHeight: "100vh", height: "fit-content", ...containerStyles, marginTop: '3.5%' }}>
            <div
                className="d-flex justify-content-between"
            >
                <h5
                    className="w-100 text-center"
                    style={{ marginBottom: "0rem",fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-large)", }}
                >
                    Privacy policy
                </h5>
            </div>
            <div
                // className={styles.child}
                className="d-flex flex-column gap-1" // Reduce gap between elements
                style={{
                    ...containerStyles,
                    height: "70vh",
                    overflowY: "auto",
                    borderRadius: "8px",
                    padding: "0 1rem 1rem 1rem"
                }}>
                <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)",}}>
                    At LeadsRubix Private Limited, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and disclose your personal information when you use our mobile app, leadsRubix.
                </span>
                <h6 style={{margin: "0.1rem 0", padding:0, paddingTop: "10px",fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)",}}>Information We Collect</h6>
                <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    When you use our app, we may collect the following types of personal information:
                </span>
                <li>
                    Name, email address, and other contact details
                </li>
                <li>
                    Usernames and passwords
                </li>
                <li>
                    Location information, if you choose to enable this feature
                </li>
                <h6 style={{margin: "0.1rem 0", padding:0, paddingTop: "10px",fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)"}}>Use of Information</h6>
               <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    We may use your personal information for the following purposes:
                </span>
                <li style={{fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    To provide and improve our app
                </li>
                <li style={{fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    To personalize your experience
                </li>
                <li style={{fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    To communicate with you, including to respond to your inquiries and provide customer support
                </li>
                <li >
                    To send you marketing and promotional materials, subject to your consent
                </li>
                <li style={{fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    To comply with legal obligations
                </li>
                <h6 style={{margin: "0.1rem 0", padding:0, paddingTop: "10px",fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)"}}>
                    Disclosure of Information
                </h6>
                <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    We may disclose your personal information to the following third parties:
                </span>
                <li style={{fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    Law enforcement authorities, regulators, or other government officials, when required by law or to protect our rights or the rights of others
                </li>
                <li style={{fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    Other users of our app, when you choose to share information with them through the app Security
                </li>
                <li style={{fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    We take reasonable measures to protect your personal information from unauthorized access, use, and disclosure. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee the absolute security of your information.
                </li>
                <h6 style={{margin: "0.1rem 0", padding:0, paddingTop: "10px",fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)"}}>
                    Security
                </h6>
                <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    We take reasonable measures to protect your personal information from unauthorized access, use, and disclosure. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee the absolute security of your information.
                </span>
                <h6 style={{margin: "0.1rem 0", padding:0, paddingTop: "10px",fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)"}}>
                    Retention
                </h6>
               <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    We will retain your personal information for as long as necessary to fulfill the purposes for which it was collected, unless a longer retention period is required or permitted by law.
                </span>
                <h6 style={{margin: "0.1rem 0", padding:0, paddingTop: "10px",fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)"}}>Your Rights</h6>
                <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    You may have certain rights with respect to your personal information, such as the right to access, correct, or delete your information. If you wish to exercise these rights, please contact us using the information provided on Contact us section.
                </span>
                <h6 style={{margin: "0.1rem 0", padding:0, paddingTop: "10px",fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)"}}>
                    Changes to this Policy
                </h6>
                <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations. We will post the updated Privacy Policy on our website and notify you of any material changes.
                </span>
               <h6 style={{margin: "0.1rem 0", padding:0, paddingTop: "10px",fontFamily: "var(--font-family-main)",
                     fontSize: "var(--font-size-medium)"}}>Contact us</h6>
                <span style={{margin: "0.1rem 0", padding:0,fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"}}>
                    If you have any questions or concerns about this Privacy Policy or our practices, please contact us at info@leadsrubix.com
                </span>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        theme: state.theme.isLightMode
    };
};

export default connect(mapStateToProps)(PolicyPrivacy);